"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        /**
         * Framework class for AppBarSection control
         */
        var AppBarSection = /** @class */ (function (_super) {
            __extends(AppBarSection, _super);
            function AppBarSection() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(AppBarSection.prototype, "$overflowArea", {
                /**
                 * Retrieves the object representing AppBar overflow area
                 * @returns AppBar overflow area
                 */
                get: function () {
                    if (!this._overflowArea || !this._overflowArea.length) {
                        this._overflowArea = $(".overflow-menu", this.$toolbar);
                    }
                    return this._overflowArea;
                },
                enumerable: false,
                configurable: true
            });
            AppBarSection.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                this.OverflowMenuOpen = $dyn.observable(false);
                this.ShowOverflowButton = $dyn.observable(false);
                this.$toolbar = $(".appBar-toolbar", element);
                this.externalHostedButton = false;
                this.hostedFilterButton = undefined;
                this.hostedSimpleListButton = undefined;
                this.hostedRelatedInfoButton = undefined;
                /**
                 * Calculates width of all AppBar children and stores them for later use.
                 */
                var calculateChildWidths = function () {
                    _this.$toolbar.children().each(function (index, toolbarChildElement) {
                        if (toolbarChildElement.getAttribute("data-dyn-role") === "ActionGroup") {
                            // For ActionGroups just put the width as the margin, the content
                            // width will be measured on each child since they can move
                            // independent of the whole group.
                            toolbarChildElement.dynWidth = parseInt(window.getComputedStyle(toolbarChildElement).marginLeft, 10);
                            $(toolbarChildElement).children().each(function (childIndex, childElement) {
                                childElement.dynWidth = childElement.offsetWidth;
                            });
                        }
                        else {
                            toolbarChildElement.dynWidth = toolbarChildElement.offsetWidth + parseInt(window.getComputedStyle(toolbarChildElement).marginLeft, 10);
                        }
                    });
                    var rightContent = _this.$toolbar.children(".actionGroup-right")[0];
                    var overflowButton = $(rightContent).parent().children(".appBar-overflow")[0];
                    if (!_this.ShowOverflowButton() && rightContent && overflowButton) {
                        rightContent.dynWidth += parseInt(window.getComputedStyle(overflowButton).width, 10);
                    }
                    // if in zoom mode we need to reserve these items size
                    if ($dyn.value($dyn.shell.zoomModeWidth)) {
                        var filterButton = $(rightContent).children(".button_showFilters")[0];
                        if (rightContent && filterButton) {
                            rightContent.dynWidth += parseInt(window.getComputedStyle(filterButton).width, 10);
                        }
                        // see if zoom mode and are Filter/list/related in the bar
                        var listButton = $(rightContent).children(".button_showList")[0];
                        if (rightContent && listButton) {
                            rightContent.dynWidth += parseInt(window.getComputedStyle(listButton).width, 10);
                        }
                        // see if zoom mode and are Filter/list/related in the bar
                        var relatedinfoButton = $(rightContent).children(".factBoxPane-toggleButton")[0];
                        if (rightContent && filterButton) {
                            rightContent.dynWidth += parseInt(window.getComputedStyle(relatedinfoButton).width, 10);
                        }
                    }
                };
                /**
                 * Retrieves width of AppBar content.
                 * @returns Width of AppBar content
                 */
                var appBarContentWidth = function () {
                    var contentWidth = 0;
                    _this.$toolbar.children().each(function (index, toolbarChildElement) {
                        contentWidth += toolbarChildElement.dynWidth;
                        if (toolbarChildElement.getAttribute("data-dyn-role") === "ActionGroup") {
                            // For ActionGroups we need to also include the width of each child.
                            $(toolbarChildElement).children().each(function (childIndex, childElement) {
                                contentWidth += childElement.dynWidth;
                            });
                        }
                    });
                    return contentWidth;
                };
                // Defined in init instead of prototype because function is used as an event handler and needs the correct this context
                this._removeAllOverflow = function () {
                    var removeableItems = $(".appBar-overflow-item", _this.$overflowArea);
                    var removeList = _this._reverseJqueryList(removeableItems);
                    $dyn.callFunction($dyn.util.ActionPaneHelpers._removeAllOverflow, _this, removeList);
                };
                // Defined in init instead of prototype because function is used as an event handler and needs the correct this context
                this._updateOverflowThrottled = function () {
                    if (_this._updateOverflowTimeout) {
                        _this._updateOverflowTimeout.cancel();
                    }
                    _this._updateOverflowTimeout = $dyn.async(_this._updateOverflow, undefined, "AppBarSection overflow");
                    // resize function so lets see if we need to collapse the pane if it is open
                    if ($dyn.value($dyn.shell.isSmallViewPort) && $dyn.value(_this.IsPinnedOpen)) {
                        _this._removePinnedTab();
                    }
                };
                // Defined in init instead of prototype because function is used as an event handler and needs the correct this context
                this._checkCloseButtonExistance = function () {
                    // see if data-dyn-controlname="SystemDefinedCloseButton" and if stack == 1 (only form in the stack)
                    if ($dyn.length($dyn.shell.stack) === 1) {
                        var closeTarget = $(_this.element).find('[data-dyn-controlname="SystemDefinedCloseButton"]')[0];
                        if (closeTarget) {
                            $dyn.util.setVisibility(closeTarget, false);
                        }
                    }
                };
                // Defined in init because it uses local functions calculateChildWidths, appBarContentWidth
                this._updateOverflow = function () {
                    if ($dyn.value(_this.Visible)) {
                        // Retrieve/store all of the widths before we start to move content
                        // to avoid layout thrashing.
                        calculateChildWidths();
                        var elementWidth = _this.$toolbar.width();
                        // For control gallery scenarios we need to fall back to the window width
                        // since the element doesn't have a width on first load and nothing else
                        // triggers an update after that.
                        var availableSpace = elementWidth ? elementWidth : $(window).width();
                        // A note about determining which items to move. The array exposed by the jQuery
                        // object keeps all items that matched the selector the jQuery object was
                        // created with in document order. Document order is a depth first traversal.
                        // This means parent elements appear before their children and a sibling's
                        // descendent that matched the selector appear before the the next sibling.
                        if (availableSpace <= appBarContentWidth()) {
                            var moveableItems = void 0;
                            // if in zoom mode - overflow the right side elements
                            if ($dyn.value($dyn.shell.zoomModeWidth)) {
                                moveableItems = _this.$toolbar.children(":not(.actionGroup-right):not(.actionSearch):not(.appBar-overflow)")
                                    .add(_this.$toolbar.children('[data-dyn-role="ActionGroup"]')
                                    .children(":not([data-dyn-controlname='SystemDefinedCloseButton']):not(.button_showFilters):not(.button_showList):not(.factBoxPane-toggleButton)"));
                            }
                            else {
                                moveableItems = _this.$toolbar.children(":not(.actionGroup-right):not(.actionSearch):not(.appBar-overflow)")
                                    .add(_this.$toolbar.children('[data-dyn-role="ActionGroup"]:not(.actionGroup-right)').children());
                            }
                            var indexToMove = moveableItems.length - 1;
                            while (availableSpace <= appBarContentWidth() && indexToMove >= 0) {
                                _this._moveItemToOverflow(moveableItems[indexToMove]);
                                indexToMove--;
                            }
                        }
                        else {
                            var removeableItems = $(".appBar-overflow-item", _this.$overflowArea);
                            // check if space is close - if so run this loop - purly an optimization so we dont always do this;
                            if (availableSpace > appBarContentWidth()) {
                                var removeList = _this._reverseJqueryList(removeableItems);
                                if (removeList && removeList.length) {
                                    var indexToMove = 0;
                                    while (indexToMove <= removeList.length - 1 && availableSpace > (appBarContentWidth() + removeList[indexToMove].dynWidth)) {
                                        _this._removeItemFromOverflow(removeList[indexToMove]);
                                        indexToMove++;
                                    }
                                }
                            }
                        }
                        if (_this._checkOverflowAreaHasChildren()) {
                            _this.ShowOverflowButton(true);
                        }
                        else {
                            _this.ShowOverflowButton(false);
                            if (_this.OverflowMenuOpen()) {
                                _this.OverflowMenuOpen(false);
                            }
                        }
                    }
                };
                this._appBarWatchedContent = $dyn.computed(function () {
                    var e_1, _a, e_2, _b;
                    var children = $dyn.value(_this.Children);
                    if (children) {
                        try {
                            for (var children_1 = __values(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
                                var child = children_1_1.value;
                                if (child.TypeName === "AppBarTab") {
                                    $dyn.value(child.Visible);
                                    $dyn.value(child.Label);
                                }
                                else if (child.TypeName === "ActionGroup") {
                                    $dyn.value(child.Visible);
                                    var groupChildren = $dyn.value(child.Children);
                                    try {
                                        for (var groupChildren_1 = (e_2 = void 0, __values(groupChildren)), groupChildren_1_1 = groupChildren_1.next(); !groupChildren_1_1.done; groupChildren_1_1 = groupChildren_1.next()) {
                                            var groupChild = groupChildren_1_1.value;
                                            $dyn.value(groupChild.Visible);
                                            $dyn.value(groupChild.Label);
                                        }
                                    }
                                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                    finally {
                                        try {
                                            if (groupChildren_1_1 && !groupChildren_1_1.done && (_b = groupChildren_1.return)) _b.call(groupChildren_1);
                                        }
                                        finally { if (e_2) throw e_2.error; }
                                    }
                                    // special case if specail form elements are promoted to app bar during resize
                                    if (child.element.classList.contains("actionGroup-right") && _this.externalHostedButton) {
                                        if (_this.hostedFilterButton === undefined) {
                                            _this.hostedFilterButton = $dyn.context(child.element.getElementsByClassName("button_showFilters")[0]);
                                        }
                                        if (_this.hostedFilterButton !== undefined) {
                                            $dyn.value(_this.hostedFilterButton.Visible);
                                            $dyn.value(_this.hostedFilterButton.Label);
                                        }
                                        if (_this.hostedSimpleListButton === undefined) {
                                            _this.hostedSimpleListButton = $dyn.context(child.element.getElementsByClassName("button_showList")[0]);
                                        }
                                        if (_this.hostedSimpleListButton !== undefined) {
                                            $dyn.value(_this.hostedSimpleListButton.Visible);
                                            $dyn.value(_this.hostedSimpleListButton.Label);
                                        }
                                        if (_this.hostedRelatedInfoButton === undefined) {
                                            _this.hostedRelatedInfoButton = $dyn.context(child.element.getElementsByClassName("factBoxPane-toggleButton")[0]);
                                        }
                                        if (_this.hostedRelatedInfoButton !== undefined) {
                                            $dyn.value(_this.hostedRelatedInfoButton.Visible);
                                            $dyn.value(_this.hostedRelatedInfoButton.Label);
                                        }
                                        if (_this.hostedFilterButton === undefined && _this.hostedSimpleListButton === undefined && _this.hostedRelatedInfoButton === undefined) {
                                            // no buttons found so reset the global
                                            _this.externalHostedButton = false;
                                        }
                                    }
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (children_1_1 && !children_1_1.done && (_a = children_1.return)) _a.call(children_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                    }
                    // Add the expand/collapsed observable to the watched context computed scope
                    var actionSearchControl = $dyn.context($(_this.element).find('[data-dyn-role="AppBarSearchField"]')[0]);
                    if (actionSearchControl) {
                        $dyn.value(actionSearchControl.SearchFieldShown);
                    }
                });
                this._zoomModeWidthObserver = $dyn.observe($dyn.shell.zoomModeWidth, function (value) {
                    // this gets toggled when we go in and out of zoom mode, we always want to reset the overflow
                    _this._removeAllOverflow();
                });
                $dyn.observe(this.Children, function (value) {
                    if (_this._pinnedTab && value.indexOf(_this._pinnedTab) === -1) {
                        // The pinned tab has been removed from the children, clear the pinned content of the AppBar.
                        _this._removePinnedTab();
                    }
                });
                $dyn.observe(this.IsPinnedOpen, function (value) {
                    if (value) {
                        if ($dyn.value(_this.LastActiveTabName)) {
                            _this._pinTabByTabName($dyn.value(_this.LastActiveTabName));
                        }
                    }
                    else {
                        _this._removePinnedTab();
                    }
                    // Need to reflow root because form container space could have changed
                    if (_this.Root) {
                        _this.Root.reflow();
                    }
                });
                $dyn.observe(this.LastActiveTabName, function (newValue) {
                    if ($dyn.value(_this.IsPinnedOpen)) {
                        _this._pinTabByTabName(newValue);
                    }
                });
                // We need to update the overflow whenever window is resized or isAsidePaneOpen changes.
                this._isAsidePaneOpenOverflowSubscription = $dyn.shell.isAsidePaneOpen.valueChanged.subscribe(this._updateOverflowThrottled, this);
                $(window).on("resize", this._updateOverflowThrottled);
                // Watching the children only doesn't work in vrtt gallery / no server
                // scenarios since the observe on the watched content happens before the
                // content is visible and doesn't allow the size calculations to work correctly.
                $(document.body).on("resetShellOnNavigation", this._updateOverflowThrottled);
                // check for embedded scenario changes
                if ($dyn.isEmbedded) {
                    $(document.body).on("resetShellOnNavigation", this._checkCloseButtonExistance);
                }
                // We need to update the overflow whenever our watched content changes.
                this._watchedContentOverflowSubscription = $dyn.observe(this._appBarWatchedContent, this._updateOverflowThrottled);
                // If a replace is happening on any children elements we need to
                // undo the moves the overflow logic has done before that code runs
                // and re-run overflow after it finishes.
                this.$toolbar.on("contentHandlersReplaceStarted", this._removeAllOverflow);
                this.$toolbar.on("contentHandlersReplaceFinished", this._updateOverflowThrottled);
            };
            AppBarSection.prototype.addHostedButton = function (newElement) {
                var destElement = $(this.element).find('[data-dyn-controlname="SystemDefinedCloseButton"]')[0];
                if (newElement && destElement) {
                    this.externalHostedButton = true;
                    destElement.parentNode.insertBefore(newElement, destElement);
                }
            };
            /**
             * This is the handler called when the AppBar overflow flyout is open and a click event is detected. Determines if the flyout should stay open.
             * @internal
             * @param options The click options from the flyout binding handler
             * @returns true if the AppBar overflow flyout should be closed by the click; otherwise, false
             */
            AppBarSection.prototype.overflowClickSubscriber = function (options) {
                var $target = $(options.clickTarget);
                // Don't close the flyout if a right-click was performed, or if the click came from an element in our flyout that will open another flyout
                // or if it came from clicking on empty/disabled content in the flyout.
                return !(options.isRightClick ||
                    (options.flyoutElement &&
                        $target.closest(options.flyoutElement).length &&
                        ($target.is(options.flyoutElement) || $target.closest(".dropDialogButton, .flyoutButton-Button, [disabled]").length)));
            };
            AppBarSection.prototype.dispose = function () {
                if (this._updateOverflowTimeout) {
                    this._updateOverflowTimeout.cancel();
                    this._updateOverflowTimeout = undefined;
                }
                this.$toolbar.off("contentHandlersReplaceStarted", this._removeAllOverflow);
                this.$toolbar.off("contentHandlersReplaceFinished", this._updateOverflowThrottled);
                $(document.body).off("resetShellOnNavigation", this._updateOverflowThrottled);
                $(document.body).off("resetShellOnNavigation", this._checkCloseButtonExistance);
                $(window).off("resize", this._updateOverflowThrottled);
                $dyn.shell.isAsidePaneOpen.valueChanged.unsubscribe(this._isAsidePaneOpenOverflowSubscription);
                if (this._watchedContentOverflowSubscription) {
                    this._watchedContentOverflowSubscription.dispose();
                    this._watchedContentOverflowSubscription = null;
                }
                // clear observable
                if (this._zoomModeWidthObserver) {
                    this._zoomModeWidthObserver.dispose();
                    this._zoomModeWidthObserver = undefined;
                }
                _super.prototype.dispose.call(this);
            };
            /**
             * Removes specified item from the AppBar overflow area.
             * @internal
             * @param itemToMove Item to be removed from the overflow area
             */
            AppBarSection.prototype._removeItemFromOverflow = function (itemToMove) {
                var isRightGroup = false;
                // check if this is for the right side group
                if ($(itemToMove).hasClass("appBar-overflow-item-right")) {
                    isRightGroup = true;
                }
                $(itemToMove).detach();
                itemToMove.classList.remove("appBar-overflow-item", "appBar-overflow-item-right");
                var role = itemToMove.getAttribute("data-dyn-role");
                if (role === "ActionGroup" || role === "AppBarTab" || itemToMove.classList.contains("actionPane-replace")) {
                    $(".actionSearch", this.$toolbar).before(itemToMove);
                }
                else {
                    // Content is part of a group and needs to move into the last ActionGroup still in the toolbar.
                    if (isRightGroup) {
                        this.$toolbar.children(".actionGroup-right").children().last().before(itemToMove);
                    }
                    else {
                        this.$toolbar.children('[data-dyn-role="ActionGroup"]:not(.actionGroup-right)').last().append(itemToMove);
                    }
                }
                var controlToMove = $dyn.context(itemToMove);
                if (controlToMove) {
                    $dyn.util.ActionPaneHelpers.ApplyBarOverflow(controlToMove, false);
                    if (controlToMove.overflowMenuUpdate) {
                        controlToMove.overflowMenuUpdate(false);
                    }
                }
            };
            /**
             * Pins the specified AppBarTab.
             * @internal
             * @param tab The AppBarTab to be pinned
             * @param tabContentElement DOM element for AppBarTab flyout
             * @param handleFocus Whether or not to set focus after pinning tab
             */
            AppBarSection.prototype._setPinnedTab = function (tab, tabContentElement, handleFocus) {
                if (handleFocus === void 0) { handleFocus = false; }
                // Remove the current pinned tab, if any.
                this._removePinnedTab();
                // only update the pinned tab if the ActionPane is pinned open
                if (this.IsPinnedOpen()) {
                    this._pinnedTab = tab;
                    $(tabContentElement).detach().appendTo(this.element);
                    $dyn.util.setVisibility(tabContentElement, true, true);
                    tab.Expanded(true);
                    tab.element.querySelector(".appBarTab-header").setAttribute("aria-expanded", "true");
                    if (handleFocus) {
                        $dyn.util.flyout.focusFirstControlInFlyout(tabContentElement);
                    }
                }
            };
            /**
             * Un-pin the currently pinned AppBarTab
             * @internal
             * @param handleFocus Whether or not to set focus after pinning tab
             */
            AppBarSection.prototype._removePinnedTab = function (handleFocus) {
                if (handleFocus === void 0) { handleFocus = false; }
                if (this._pinnedTab) {
                    this._pinnedTab.Expanded(false);
                    this._pinnedTab.element.querySelector(".appBarTab-header").setAttribute("aria-expanded", "false");
                    $dyn.util.setVisibility(this._pinnedTab._tabFlyoutElement, false, true);
                    $(this._pinnedTab._tabFlyoutElement).detach().appendTo(this._pinnedTab.element);
                    if (handleFocus && this._pinnedTab.Root && this._pinnedTab.Root.setControlFocus) {
                        this._pinnedTab.Root.setControlFocus(this._pinnedTab.element);
                    }
                    this._pinnedTab = undefined;
                }
            };
            /**
             * Moves specified item to the AppBar overflow area.
             * @param itemToMove Item to be moved to the overflow area
             */
            AppBarSection.prototype._moveItemToOverflow = function (itemToMove) {
                var _this = this;
                // reverse the jquery list
                var reverseOverFlowList = function () {
                    var item = _this.$overflowArea.children().length - 1;
                    var reversedList = [];
                    while (item >= 0) {
                        reversedList.push(_this.$overflowArea.children()[item]);
                        item--;
                    }
                    $(reversedList).appendTo(_this.$overflowArea);
                };
                if ($dyn.ui.removeFocus($(itemToMove))) {
                    // If removeFocus returned something we need to set the overflow as the new focused element, in a time out since it isn't initially visible.
                    $dyn.async(function () {
                        $(".appBar-overflow", _this.$toolbar).focus();
                    }, undefined, "Move focus to overflow button");
                }
                if ($(itemToMove.parentElement).hasClass("actionGroup-right")) {
                    itemToMove.classList.add("appBar-overflow-item-right");
                }
                $(itemToMove).detach();
                itemToMove.classList.add("appBar-overflow-item");
                var role = itemToMove.getAttribute("data-dyn-role");
                // the dom is shown in LIFO order, but we need to process in revese order so we walk dom top down
                // reverse the list
                reverseOverFlowList();
                if (role === "AppBarTab" || itemToMove.classList.contains("actionGroup-overflow") || itemToMove.classList.contains("actionPane-replace")) {
                    this.$overflowArea.append(itemToMove);
                }
                else {
                    // Content is part of a group and needs to move into the last actionGroup-overflow area added.
                    this.$overflowArea.children(".actionGroup-overflow").last().prepend(itemToMove);
                }
                // now reverse so it will be shown LIFO order
                reverseOverFlowList();
                var controlToMove = $dyn.context(itemToMove);
                if (controlToMove) {
                    $dyn.util.ActionPaneHelpers.ApplyBarOverflow(controlToMove, true);
                    if (controlToMove.overflowMenuUpdate) {
                        controlToMove.overflowMenuUpdate(true);
                    }
                }
            };
            /**
             * Checks if overflow area has children.
             * @description Returns false if the children are only tabbing container elements
             * @returns true if has children
             */
            AppBarSection.prototype._checkOverflowAreaHasChildren = function () {
                if (!this.$overflowArea.children() || !this.$overflowArea.children().length) {
                    return false;
                }
                else if (this.$overflowArea.children().length === 2 &&
                    $(this.$overflowArea.children()[0]).hasClass("firstFocusable") &&
                    $(this.$overflowArea.children()[1]).hasClass("lastFocusable")) {
                    return false;
                }
                return true;
            };
            /**
             * takes the passed in array and reverses preserving child and jquery properties
             * @param originalJqueryList the original array to reverse
             * @returns Array of reversed elements.
             */
            AppBarSection.prototype._reverseJqueryList = function (originalJqueryList) {
                var removeList = [];
                var itemToMove = 0;
                // we need to see if any child elements are overflow and move them above the parent
                // this is so we process in top down order for overflowing correctly
                while (itemToMove <= originalJqueryList.length - 1) {
                    $(originalJqueryList[itemToMove]).find(".appBar-overflow-item").each(function (index, childElement) {
                        // this child is a overflow item so move it above parent (current parent)
                        removeList.push(childElement);
                        // now clear out the item that was found - for somereason .remove() doenst actually remove in jquery
                        var itemToRemove = itemToMove + 1;
                        while (itemToRemove <= originalJqueryList.length - 1) {
                            if (originalJqueryList[itemToRemove] === childElement) {
                                originalJqueryList[itemToRemove] = undefined;
                                break;
                            }
                            itemToRemove++;
                        }
                    });
                    // make sure we didnt clear this out
                    if (originalJqueryList[itemToMove] !== undefined) {
                        removeList.push(originalJqueryList[itemToMove]);
                    }
                    itemToMove++;
                }
                return removeList;
            };
            AppBarSection.prototype._pinTabByTabName = function (tabName) {
                var e_3, _a;
                var children = $dyn.value(this.Children);
                if (children) {
                    var _loop_1 = function (child) {
                        if (child && child._tabFlyoutElement && child.TypeName === "AppBarTab" && child.Name === tabName) {
                            var childAsTab_1 = child;
                            if (!$dyn.value(childAsTab_1.Expanded) && childAsTab_1.TabShown) {
                                // $dyn.async is required so that this is not part of process interaction of other command, like if setActivetabLastName is called on a button click in X++
                                // then tab shown will be ignored because it will be part of processing click command interaction
                                // If tab shown is not done then controls inside the tab will not come from server for rendering
                                $dyn.async(function () {
                                    $dyn.applyFunction(childAsTab_1.TabShown, childAsTab_1);
                                }, undefined, "async call triggered for tab shown when last active tab name observable changed from server");
                            }
                            this_1._setPinnedTab(childAsTab_1, childAsTab_1._tabFlyoutElement, true);
                            return "break";
                        }
                    };
                    var this_1 = this;
                    try {
                        for (var children_2 = __values(children), children_2_1 = children_2.next(); !children_2_1.done; children_2_1 = children_2.next()) {
                            var child = children_2_1.value;
                            var state_1 = _loop_1(child);
                            if (state_1 === "break")
                                break;
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (children_2_1 && !children_2_1.done && (_a = children_2.return)) _a.call(children_2);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                }
            };
            return AppBarSection;
        }($dyn.ui.Container));
        controls.AppBarSection = AppBarSection;
        $dyn.ui.addObservablePropertiesToPrototype(AppBarSection.prototype, {
            IsPinnedOpen: false,
            LastActiveTabName: "",
        });
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=AppBarSection.js.map
